<div class="tags-list">
  <div class="line-clamp-1 tags-list__tag" *ngFor="let tag of tags">
    {{ tag.name }}
  </div>
</div>
